import { SVGProps } from "react";

const StatementsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="current"
    stroke="current"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.2326 20.3057H9.76744C5.72651 20.3057 4 18.5792 4 14.5382V10.0731C4 6.03218 5.72651 4.30566 9.76744 4.30566H13.4884C13.7935 4.30566 14.0465 4.55869 14.0465 4.8638C14.0465 5.16892 13.7935 5.42194 13.4884 5.42194H9.76744C6.33674 5.42194 5.11628 6.64241 5.11628 10.0731V14.5382C5.11628 17.9689 6.33674 19.1894 9.76744 19.1894H14.2326C17.6633 19.1894 18.8837 17.9689 18.8837 14.5382V10.8173C18.8837 10.5122 19.1367 10.2592 19.4419 10.2592C19.747 10.2592 20 10.5122 20 10.8173V14.5382C20 18.5792 18.2735 20.3057 14.2326 20.3057Z" />
    <path d="M19.4419 11.3754H16.4651C13.92 11.3754 12.9302 10.3857 12.9302 7.84055V4.8638C12.9302 4.64055 13.0642 4.43218 13.2726 4.35032C13.4809 4.26101 13.7191 4.31311 13.8828 4.46939L19.8363 10.4229C19.9926 10.5792 20.0447 10.8247 19.9553 11.0331C19.866 11.2415 19.6651 11.3754 19.4419 11.3754ZM14.0465 6.21078V7.84055C14.0465 9.76055 14.5451 10.2592 16.4651 10.2592H18.0949L14.0465 6.21078Z" />
    <path d="M12.7442 13.608H8.27907C7.97395 13.608 7.72093 13.355 7.72093 13.0499C7.72093 12.7447 7.97395 12.4917 8.27907 12.4917H12.7442C13.0493 12.4917 13.3023 12.7447 13.3023 13.0499C13.3023 13.355 13.0493 13.608 12.7442 13.608Z" />
    <path d="M11.2558 16.5847H8.27907C7.97395 16.5847 7.72093 16.3317 7.72093 16.0266C7.72093 15.7215 7.97395 15.4685 8.27907 15.4685H11.2558C11.5609 15.4685 11.814 15.7215 11.814 16.0266C11.814 16.3317 11.5609 16.5847 11.2558 16.5847Z" />
  </svg>
);

export default StatementsIcon;
